<template>
  <div class="home">
    <el-carousel height="390px">
      <el-carousel-item v-for="(items,index) in imagelist" :key="index">
        <el-image  @click="carouselClick(items)" :src="items.pictureUrl" style="width:100%;height:inherit" fit="fill"></el-image>
      </el-carousel-item>
    </el-carousel>

    <div class="block" style="padding: 20px;">

      <div style="display: flex; flex-direction: row;margin: 10px auto;width: 80%;justify-content: space-between">

        <div style="padding: 0 20px;width: 80%;background-color:#fff;margin-right: 20px;">
            <div style="margin: 20px auto; ">
                <div class="headerTitleClass2" >
                  <h3>
                    交易信息
                    <span style="float: right;font-weight: normal;font-size: 14px;color: #999;" @click="skipJY()">
                  更多
                  <i class="el-icon-arrow-right"></i>
              </span>
                  </h3>

          </div>

            </div>
          <el-tabs style="min-height: 500px;" v-model="activeName" type="card" @tab-click="handleClick">
            <el-tab-pane v-for="(item, index) in leftTitleList" :key="index" :label="item.label" :name="item.value" class="tabPaneClass scroll">
              <ul style="">
                <li
                    class="flex_content ispointer texthover"
                    v-for="(item, index) in dataList"
                    :key="index"
                    style="margin-bottom: 25px;font-size: 15px"
                    @click="goToPage(item.id)"
                >
                  <div style="width: 940px;">
                    <span>【{{ item.areaName }}】</span>
                    <span v-text="item.ggName"></span>
                  </div>
                  <div style="color: #999" v-text="item.ggStartTime.substring(0,10)"></div>
                </li>
              </ul>
            </el-tab-pane>
          </el-tabs>
        </div>

        <div class="right" style="background-color:#fff;width: 400px;">
          <div class="headerTitleClass2" style="margin: 20px 0 20px 20px;">
            <h3>登录入口</h3>
          </div>
          <el-link style="display: block;margin-bottom: 10px;" :underline="false" v-for="(item, index) in imagelist1" @click="routerToClick(item)" :key="index">
            <div style="width: 320px;height: 80px;text-align: center;line-height: 80px;color: #FFFFFF;font-size: 20px;position: relative;margin:0 auto" :style="'background: url(' + item.img +')'">
              <div class="graybg"></div>
              <div
                  style="position: absolute;top: 10px;right: 60px;width: 240px;text-align: center;display: flex;flex-direction: row">
                <div style="height: 40px;">
                  <el-image style="height: 30px;" :src="item.icon"></el-image>
                </div>
                <div style="height: 40px;margin: -6px 20px;width: 140px;text-align: left">{{ item.title }}</div>
                <div style="height: 40px;">
                  <el-image style="height: 30px;" :src="getInto"></el-image>
                </div>
              </div>
            </div>
          </el-link>
        </div>
      </div>

      <div class="card1"></div>

      <div style="display: flex; flex-direction: row;margin: 10px auto;width: 80%;justify-content: space-between">
        <div style="padding: 20px;width: 80%;background-color:#fff;margin-right: 20px;">
          <div style="margin-bottom: 24px;">
            <div class="headerTitleClass2" >
              <h3>新闻公告</h3>
            </div>
          </div>
          <div>
            <ul class="scroll news_list">
              <li
                  style="display: flex;flex-direction: row;margin-bottom: 22px;"
                  v-for="(item, index) in xwlist"
                  :key="index"
                  @click="goNewsDetail(item.id)"
              >
                <div style="width: 230px;height: 140px; margin-right: 20px;">
                  <div class="block">
                    <el-image :src="item.imageUrl">
                      <div slot="error" class="image-slot">
                        <el-image :src="require('../assets/images/xw.png')"></el-image>
                      </div>
                    </el-image>
                  </div>
                </div>

                <div style="width: 730px; display: flex;flex-direction: column;justify-content: space-around;">
                  <p class="con_h">
                    {{ item.title }}
                  </p>
                  <!-- <p class="detailthml" v-html="item.details"></p> -->
                  <p class="flex_content">
                    <span>{{ item.createTime.substring(0, 10) }}</span>
                  </p>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="right" style="background-color:#fff;width: 400px;padding: 20px;box-sizing: border-box;">
          <div class="headerTitleClass2">
            <h3>工具下载</h3>
          </div>
          <div style="display: block;margin-bottom: 10px;" :underline="false" v-for="(item, index) in toollist"  :key="index">
            <div :class="{'toolitem':true,'action':toolaction===index}" @click="downloadClick(item,index)">
              <div style="width: 300px;height: inherit;text-align: center;display: flex;flex-direction: row;justify-content: space-around;align-items: center;">
                <!-- <div> -->
                    <el-image  style="width: 55px;height: 55px;" :src="item.imageUrl">
                      <div slot="error" class="image-slot">
                        <el-image :src="require('../assets/images/tools.png')"></el-image>
                      </div>
                    </el-image>
                <!-- </div> -->
                <div style="text-align: left;width: 200px;margin-left: 10px;">{{ item.commonName }}</div>
                <div class="aftimg"></div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import {getTransactionList, xinwenlist, toolslist, lbimages, getGgList} from "@@/api/api";
import owner from '@@/assets/images/owner.png'
import bidder from '@@/assets/images/bidder.png'
import agency from '@@/assets/images/agency.png'
import expert from '@@/assets/images/expert.png'
import ownerIcon from '@@/assets/images/ownerIcon.png'
import bidderIcon from '@@/assets/images/bidderIcon.png'
import agencyOrg from '@@/assets/images/agencyOrg.png'
import expertIcon from '@@/assets/images/expertIcon.png'
import getInto from '@@/assets/images/getInto.png'

export default {
  data() {
    return {
      toolaction: '',
      activeName: "first",
      getInto,
      leftTitleList: [
        {
          label: "招标公告",
          id: "1",
          value: 'zbgg'
        },
        {
          label: "变更公告",
          id: "2",
          value: 'bggg'
        },
        {
          label: "资格预审公告",
          id: "3",
          value: 'zgysgg'
        },
        {
          label: "中标候选人公示",
          id: "4",
          value: 'zhongbiaohxrgs'
        },
        {
          label: "中标公告",
          id: "5",
          value: 'zhongbiaogg'
        }
      ],

      dataList: [],
      dataList1: [],
      dataList2: [],
      dataList3: [],
      dataList4: [],
      dataList5: [],
      content1dataList: [],
      imagelist: [],//轮播图列表
      // 交易信息右侧导航
      imagelist1: [
        {
          img: owner,
          title: "业主登录",
          path: "/login?type=1",
          icon: ownerIcon
        },
        {
          img: bidder,
          title: "投标人登录",
          path: "/login?type=2",
          icon: bidderIcon
        },
        {
          img: agency,
          title: "代理机构登录",
          path: "/login?type=3",
          icon: agencyOrg
        },
        {
          img: expert,
          title: "评标专家登录",
          path: "expert",
          icon: expertIcon
        },
        // {
        //   img: owner,
        //   title: "市场登陆",
        //   path: "/login?type=4",
        //   icon: expertIcon
        // },
      ],
      //新闻公告
      xwlist: [],
      toollist: [],//工具栏
    };
  },
  created() {
    //调用方法 zbgg   zgysgg bggg zhongbiaohxrgs   zhongbiaogg
    this.getGgList('zbgg');
    this.activeName = 'zbgg'
    this.xinwenlist()
    this.toolslist()
    this.lbimages()
  },
  methods: {
    carouselClick(item){
      window.open(item.jumpAddress, '_blank');
    },
    // 跳转公告详情
    goToPage(id) {
      let routeData = this.$router.resolve({path: "/ggDetail", query: {id: id}});
      //必要操作，否则不会打开新页面
      window.open(routeData.href, '_blank');
    },
    // 跳转新闻公告详情
    goNewsDetail(id) {
      let routeData = this.$router.resolve({path: "/newsDetail", query: {id: id}});
      //必要操作，否则不会打开新页面
      window.open(routeData.href, '_blank');
    },
    routerToClick(row) {
      if (row.path == "expert") {
        window.location.href = `${process.env.VUE_APP_LOGINURL}/ui/#/login2`
      } else {
        window.location.href = `${process.env.VUE_APP_LOGINURL}${row.path}`
      }
    },
    handleClick(tab, event) {
      this.activeName = tab.name
      this.getGgList(tab.name)
    },
    toPage(path) {
      this.$router.push(path);
    },
    skipJY(val) {
      this.$router.push({
        path: "/about",
        query: {
          id: val ? '11' : '1'
        }
      });
      this.$bus.$emit("changeMainNav", "/about");
    },
    getGgList(val) {
      let data={
        ggAnnouncement:val,
        pageSize: 10,
        page: 1
      }
      getGgList(data).then((res) => {
        if (res.code == 200) {
          this.dataList = res.data.items
        }
      });
    },
    //查询轮播图图片
    lbimages() {
      lbimages().then(res => {
        if (res.code == 200) {
          this.imagelist = res.data.items
        }
      })
    },
    //查询新闻列表
    xinwenlist() {
      xinwenlist().then(res => {
        if (res.code == 200) {
          this.xwlist = res.data.items
          console.log(res)
        }
      })
    },

    //查询工具栏列表
    toolslist() {
      toolslist().then(res => {
        if (res.code == 200) {
          this.toollist = res.data.items
          // this.toollist.push({commonName:'测试'})
          // this.toollist.push({commonName:'测试'})
        }
      })
    },

    downloadClick(row, index) {
      // this.toolaction = index
      window.open(row.commonTool)
    }
  },
};
</script>
<style scoped>
.graybg {
  background-color: rgba(0, 0, 0, 0.5);
  width: inherit;
  height: inherit;
}
.news_list li {
  cursor: pointer;
}

.news_list li:hover .con_h{
  color: #F18C1D;
}

.news_content {
  flex: 1;

}
.con_h {
  font-size: 20px;
  margin-bottom: 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.detailthml {
  font-size: 16px!important;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  line-height: 30px;
}
.toolitem{
  background-color:#ffffff;
  transition:all 0.5s;
  width: 300px;padding: 6px;
  height: 80px;
  border: 1px solid #EEEEEE;
  border-radius: 6px;
  text-align: center;
  /*line-height: 80px;*/
  font-size: 20px;
  margin: 0 auto 13px;
  cursor: pointer;
  color: #333333;
  position: relative;
  /*border-radius: 4px;*/
}
.aftimg{
    width: 30px;
  height: 30px;
  background: url(@@/assets/images/icon9.png) no-repeat;
  background-size: 100% 100%;
}
.toolitem.action .aftimg, .toolitem:hover .aftimg{
  background: url(../assets/images/icon8.png) no-repeat;
  background-size: 100% 100%;
}


.toolitem.action, .toolitem:hover {
  background-color: #F18C1D ;
  border-color: #F18C1D;
  /*color: #FFFFFF;*/
  border-radius: 10px;

}


.home {
  background-color: #F3F9FD;
}
.headerTitleClass {
  height: 30px;
  font-size: 20px;
  font-weight: bold;
  color: #F18C1D;
  padding-left: 20px;
  border-left: 8px solid #F18C1D;
}

.home {
  background-color: #F3F9FD;
}
.headerTitleClass {
  height: 30px;
  font-size: 20px;
  font-weight: bold;
  color: #F18C1D;
  padding-left: 20px;
  border-left: 8px solid #F18C1D;
}
.headerTitleClass2 {
  padding-left: 17px;
  padding-bottom: 18px;
  border-bottom: 1px solid #eee;
  position: relative;
  margin-bottom: 18px;
}
.headerTitleClass2::before {
  content: '';
  width: 6px;
  height: 22px;
  background: #F18C1D;
  position: absolute;
  left: 0;
  top: 2px;
}
::v-deep .el-tabs--card > .el-tabs__header .el-tabs__item, ::v-deep .el-tabs--card > .el-tabs__header .el-tabs__nav, ::v-deep .el-tabs--card > .el-tabs__header {
  border: none;
}

::v-deep .el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
  height: 40px;
  line-height: 40px;
  background: #F18C1D;
  border-radius: 2px;
  color: #fff;
}

::v-deep .el-tabs--card > .el-tabs__header .el-tabs__item:hover {
  /*width: 98px;*/
  height: 40px;
  line-height: 40px;
  background: #F18C1D;
  border-radius: 2px;
  color: #fff;
}

.card1 {
  height: 200px;
  width: 80%;
  background: url("@@/assets/images/card.png") no-repeat;
  background-size: cover;
  margin: 20px auto;
}

.fg {
  width: 90%;
  margin-left: 15px;
}
h3{
  color: #F18C1D;
}
</style>
